
<div class="mr-4 ml-4">
    <f-title :title="title" />
    <drop class="w-100 cut" @drop="onDrop" mode="cut" :accepts-data="onAcceptData">
        <div v-if="recipients.length === 0" class="recipients-missing">

        </div>
        <div>
            <v-carousel
                v-model         ="current"
                :continuous     ="false"
                :cycle          ="false"
                :show-arrows    ="false"
                :hide-delimiters="true"
                height          ="100%"
                class           ="pa-0 ma-0"
                light
            >
                <v-carousel-item v-for="(recipient,index) in recipients" :key="index">
                    <c-recipient-card
                        style        = "width: calc(100% - 1px)"
                        :company     = "recipient.recipient"
                        :enable-edit = "false"
                    >
                        <template v-slot:toolbar>
                            <div style="margin-top: -4px;">
                                <c-toolbar-button
                                    icon    = "mdi-close"
                                    size    = "22"
                                    color   = "red"
                                    tooltip = "Entfernen"
                                    @click  = "onRemove(recipient)"
                                />
                            </div>
                        </template>
                    </c-recipient-card>
                </v-carousel-item>
            </v-carousel>
        </div>
    </drop>
    <div class="navigation">
        <div class="v-flex" v-if="recipients.length > 1">
            <a v-for="(recipient, i) in recipients" :key="i" @click="current=i">
                <div class="delimiter primary" :class="current===i?'selected':''"></div>
            </a>
        </div>
    </div>
</div>
